import { render, staticRenderFns } from "./ParametrosSistemaCliente.vue?vue&type=template&id=203ae068&"
import script from "./ParametrosSistemaCliente.vue?vue&type=script&lang=ts&"
export * from "./ParametrosSistemaCliente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('203ae068', component.options)
    } else {
      api.reload('203ae068', component.options)
    }
    module.hot.accept("./ParametrosSistemaCliente.vue?vue&type=template&id=203ae068&", function () {
      api.rerender('203ae068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administracion/ParametrosSistemaCliente.vue"
export default component.exports